module.exports = __webpack_public_path__ + "img/chevron-down.03409aee.svg";